interface ProgressBarProps {
  totalSteps: number;
  currentStep: number;
  width: number | string;
  className?: string;
}

export const ProgressBar = ({
  totalSteps,
  currentStep,
  className,
  width,
}: ProgressBarProps) => {
  const progressPercentage = (currentStep / totalSteps) * 100;
  return (
    <div className={`flex gap-4 items-center ${className}`}>
      <div
        style={{ width }}
        className={`h-2 bg-gray-200 rounded-full overflow-hidden `}
      >
        <div
          className={`h-full bg-primary-500 transition-all duration-300 ease-in-out`}
          style={{ width: `${progressPercentage}%` }}
        />
      </div>

      <span>{`${currentStep} of ${totalSteps}`}</span>
    </div>
  );
};
